import { render } from "./diceLoad.vue?vue&type=template&id=1fad48ac&scoped=true"
import script from "./diceLoad.vue?vue&type=script&lang=js"
export * from "./diceLoad.vue?vue&type=script&lang=js"

import "./diceLoad.vue?vue&type=style&index=0&id=1fad48ac&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fad48ac"]])

export default __exports__